<script setup>
import FormSwitch from '@/components/form/FormSwitch.vue'

const props = defineProps({
  id: String,
  name: String,
  description: String,
  value: Boolean,
  disabled: Boolean,
  icon: String,
  iconColor: String,
  attributes: Object,
})
const emit = defineEmits(['input'])

function updateProps(val) {
  emit('input', {
    id: props.id,
    value: val,
  })
}
</script>

<template>
  <div class="flex mx-6 justify-between" :class="attributes?.layout_density === 'comfortable' ? 'my-6' : 'py-3'">
    <div class="flex items-start grow max-w-[75%]">
      <span
        v-if="icon"
        class="material-symbols-outlined mr-2 mt-0.5"
        :class="attributes?.layout_density === 'comfortable' ? 'text-lg' : 'text-base'"
        :style="{ color: iconColor || attributes?.primary_color }"
        >{{ icon }}</span
      >
      <div>
        <h3 :class="attributes?.layout_density === 'comfortable' ? 'text-lg' : 'text-base'" class="font-medium">
          {{ name }}
        </h3>
        <p class="text-gray-500 text-sm">
          {{ description }}
        </p>
      </div>
    </div>

    <div class="my-auto">
      <FormSwitch :value="value" :disabled="disabled" :attributes="props.attributes" @input="updateProps" />
    </div>
  </div>
</template>
